import { noop } from 'lodash';
import { memo } from 'react';

import { type Clip } from '@air/api/types';

import { AssetGalleryCard, type AssetGalleryCardProps } from '~/components/Gallery/AssetGalleryCard/AssetGalleryCard';
import { DraggingOverlay } from '~/components/Gallery/DraggingOverlay';
import { DNDMovableToBoardItem } from '~/components/Shared/Drag/DNDMovableToBoardItem/DNDMovableToBoardItem';
import { DNDParentAsset } from '~/components/Shared/Drag/DNDParentAsset';
import DragType from '~/components/Shared/Drag/dragTypes';
import { DropHighlight } from '~/components/Shared/DropHighlight';

export type DNDAssetGalleryCardProps = {
  enableDrag?: boolean;
  index: number;
  onDragStart?: () => void;
} & AssetGalleryCardProps<Clip>;

export const DNDAssetGalleryCard = memo(
  ({ clip, enableDrag = true, index, onDragStart = noop, ...rest }: DNDAssetGalleryCardProps) => {
    return (
      <DNDMovableToBoardItem
        enabled={enableDrag}
        id={clip.id}
        index={index}
        item={{ asset: clip, assetId: clip.assetId, index, type: DragType.asset }}
        onDragStart={onDragStart}
      >
        <DNDParentAsset asset={clip} dropLocation="asset" style={{ height: '100%' }}>
          <DropHighlight borderRadius={10} />
          <AssetGalleryCard clip={clip} {...rest} />
          <DraggingOverlay itemId={clip.id} type={DragType.asset} />
        </DNDParentAsset>
      </DNDMovableToBoardItem>
    );
  },
);

DNDAssetGalleryCard.displayName = 'DNDAssetGalleryCard';
